import hyperdom from 'hyperdom'
import formatPrice from '../packages/ui-helpers/formatPrice.js'
import * as gtmDataLayer from '../analytics/gtm/dataLayer.js'

export default class Transfers {
  constructor (options) {
    this.quoteCriteria = options.quoteCriteria
    this.config = options.config
    this.departure = options.departure
    this.selected = []
    this.dmpg = options.dmpg
    this.api = options.api
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  formatPrice (price) {
    return formatPrice({
      currency: this.departure.prices.currency,
      amount: price,
    })
  }

  load () {
    var self = this

    return this.api.searchTransfers({
      sellingCompanyCode: this.config.sellingCompanyCode,
      marketVariationCode: this.departure.productCode,
      flightLegs: this.quoteCriteria.flights.flights.selected.legs,
      departureData: {
        code: this.departure.code,
        startCity: this.departure.startPlace.airport,
        endCity: this.departure.endPlace.airport,
        endDate: this.departure.endDate,
        startDate: this.departure.startDate,
        isTourPackage: this.departure.isTourPackage,
      },
      prePostAccommodation: {
        hotelsBefore: this.quoteCriteria.hotelsBefore.selectedNights,
        hotelsAfter: this.quoteCriteria.hotelsAfter.selectedNights,
      },
    }).then(transfers => {
      self.transfers = transfers
      return transfers
    })
  }

  selectById (transferIds) {
    if (transferIds && transferIds.length > 0) {
      var transfersToSelect = this.transfers.filter(transfer =>
        transferIds.indexOf(transfer.code) !== -1
      )
      this.select(transfersToSelect)
    }
  }

  select (transfers) {
    this.selected = transfers.slice(0)
    this.selected.forEach(transfer => {
      transfer.selected = true
    })
  }

  remove () {
    this.selected.forEach(transfer => {
      transfer.selected = false
    })
    this.selected = []
    delete this.transfers
  }

  toggleTransfer (transfer) {
    if (transfer.selected) {
      this.selected.push(transfer)
    } else {
      transfer.selected = false
      var indexOfTransfer = this.selected.indexOf(transfer)
      this.selected.splice(indexOfTransfer, 1)
    }
  }

  departureCode () {
    var departure = this.selected.filter(transfer => transfer.type === 'departure')[0]
    if (departure) {
      return departure.code
    }
  }

  arrivalCode () {
    var arrival = this.selected.filter(transfer => transfer.type === 'arrival')[0]
    if (arrival) {
      return arrival.code
    }
  }

  render () {
    return this.transfers ? <div class="airport-transfers">
      <div className='additional-tour__header'>
        <h2>Transfers</h2>
        <span>Optional</span>
      </div>
      <div className='o-accent-box'>
        <div class="summary">
          <p class="u-big-text">Would you like to add transfers to your flights?</p>

          <div class="o-inner-accent-box">
            {this.transfers.map(transfer => {
              return <label class={["o-choice-item -fullWidth", transfer.type]}>
                <input type="checkbox" class="o-choice-item__checkbox" binding={[transfer, 'selected', () => this.toggleTransfer(transfer)]} value={true} />
                <div class="o-choice-item__content">
                  <span class="description">{ transfer.description }</span> - <strong class="price u-no-wrap">{ transfer.amount === 0 ? 'FREE' : this.formatPrice(transfer.amount) + ' per person.' }</strong>
                </div>
              </label>
            })}

            {this.transfers.length == 0 ?
              <span class="not-available">There aren't any transfers available for your chosen flights.</span>
              :undefined
            }
          </div>
        </div>
      </div>
    </div>
      :undefined
  }
}
